document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const mobile = document.querySelector('.mobile-nav');
  if (toggle && mobile) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      mobile.hidden = open;
    });
  }

  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    form.addEventListener('submit', () => {
      setTimeout(() => window.location.reload(), 500);
    });
  });
});
